export { default } from './svg/search.svg';
